import React from "react";
import CrudPage from "@/components/CrudPage";
import { usersApi } from "@/lib/orgApi";
import { formatDateTimeUS } from "@/lib/dates";
import UserFormDrawer from "../components/UserFormDrawer";

const UsersAdminPage = () => (
    <CrudPage
        title="Users"
        subtitle="Manage caregivers, supervisors and administrators."
        api={usersApi}
        listParams={{ active: true }}
        testidPrefix="users"
        formComponent={UserFormDrawer}
        columns={[
            {
                key: "name",
                label: "Name",
                render: (r) => `${r.first_name} ${r.last_name}`,
            },
            { key: "email", label: "Email" },
            {
                key: "role",
                label: "Role",
                render: (r) => (
                    <span className="rounded-full bg-brand-blue-50 px-2.5 py-1 text-xs font-semibold text-brand-blue-800">
                        {r.role}
                    </span>
                ),
            },
            { key: "scope_type", label: "Scope" },
            {
                key: "created_at",
                label: "Created at",
                render: (r) => (
                    <span className="whitespace-nowrap font-mono text-xs text-slate-600">
                        {formatDateTimeUS(r.created_at)}
                    </span>
                ),
            },
            {
                key: "active",
                label: "Status",
                render: (r) =>
                    r.active ? (
                        <span className="rounded-full bg-brand-green-100 px-2.5 py-1 text-xs font-semibold text-brand-green-800">
                            Active
                        </span>
                    ) : (
                        <span className="rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600">
                            Inactive
                        </span>
                    ),
            },
        ]}
    />
);

export default UsersAdminPage;
